import { render, staticRenderFns } from "./SaleHistoryEventPeppolInvoiceResponseReceived.vue?vue&type=template&id=eb9f4eca"
import script from "./SaleHistoryEventPeppolInvoiceResponseReceived.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventPeppolInvoiceResponseReceived.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports